<template>
  <div class="menu-container">
    <button
      class="hamburguer"
      @click="isMenuOpen = true"
    >
      <img
        :src="hamburguerIcon"
        alt="Hamburguer icon"
      />
    </button>
    <nav
      class="appbar-items"
      :class="{ active: isMenuOpen }"
    >
      <button
        v-for="({ name, clickMethod }, i) in links"
        :key="i"
        @click="
          clickMethod();
          isMenuOpen = false;
        "
      >
        {{ name }}
      </button>
      <Button
        class="sign-in"
        background-color="#ffffff"
        border-color="#ee396c"
        font-color="#ee396c"
        @click="loginModal"
      >
        Acessar Conta
      </Button>
      <Button
        class="sign-up"
        @click="registerModal"
      >
        Criar Conta
      </Button>
    </nav>
    <div
      class="appbar-items__overlay"
      @click="isMenuOpen = false"
    ></div>
    <button
      class="appbar-items__close"
      @click="isMenuOpen = false"
    ></button>
  </div>
</template>

<script>
import Button from '@/components/Button/Button.vue';

export default {
  name: 'Navbar',
  components: {
    Button,
  },
  props: {
    links: {
      type: Array,
      default: () => [],
      require: true,
    },
    loginModal: {
      type: Function,
      default: () => [],
      require: true,
    },
    registerModal: {
      type: Function,
      default: () => [],
      require: true,
    },
  },
  data() {
    return {
      hamburguerIcon: require('../../assets/hamburguer-icon.svg'),
      isMenuOpen: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.appbar {
  .menu-container {
    @media (max-width: $lg) {
      order: 2;
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
    .hamburguer {
      display: none;
      @media (max-width: $lg) {
        display: flex;
        align-items: center;
      }
    }
  }
  &-items {
    color: #ee396c;
    margin-left: 50px;

    .sign-in,
    .sign-up {
      display: none;
    }

    @media (max-width: $lg) {
      width: 80vw;
      visibility: hidden;
      position: fixed;
      right: -100vw;
      top: 0;
      bottom: 0;
      transition: 0.5s;
      display: flex;
      flex-direction: column;
      height: 100vh;
      background-color: #ffffff;
      padding: 0 40px;
      align-items: flex-start;
      padding-top: 50px;
      z-index: 5;

      .sign-in,
      .sign-up {
        display: block;
        width: 100% !important;
        margin-top: 10px;
      }

      &.active {
        transition: 0.5s;
        visibility: visible;
        right: 0;

        ~ .appbar-items__overlay {
          opacity: 1;
          transition: 0.5s;
          visibility: visible;
        }

        ~ .appbar-items__close {
          opacity: 1;
          transition: 0.5s;
          visibility: visible;
        }
      }
    }

    button {
      color: inherit;
      text-transform: none;
      font-size: 15px;
      font-weight: 500;

      @media (max-width: $lg) {
        padding: 15px 0;
        position: relative;

        &:not(.sign-in, .sign-up) {
          &:after {
            content: '';
            display: block;
            position: relative;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 2px;
            background-color: #ee396c;
          }
        }
      }

      & + button {
        @media (min-width: $lg) {
          margin-left: 33px;
        }
      }
    }

    &__overlay {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.4);
      visibility: hidden;
      opacity: 0;
      width: 100vw;
      height: 100vh;
      transition: 0.5s;
      z-index: 2;
      cursor: pointer;
    }

    &__close {
      position: fixed;
      right: 20px;
      left: calc(8vw - 16px);
      top: 80px;
      width: 20px;
      height: 20px;
      visibility: hidden;
      opacity: 0;
      transition: 0.5s;
      z-index: 2;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:before,
      &:after {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 33px;
        width: 2px;
        background-color: #fff;
      }

      &:before {
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
